import { PlusOutlined } from "@ant-design/icons";
import { Button, message, Tooltip } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import { useHasEditPermission } from "../../common/hooks";
import DynamicTable from "../../components/DynamicTable";
import AddUserModal from "./components/AddUserModal";
import UserModal from "./components/UserModal";

function Users() {
  const [editingKey, setEditingKey] = useState(null);
  const [users, setUsers] = useState({});
  const [showUserModal, setShowUserModal] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const allowEdit = useHasEditPermission();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const res = await apiRequest({
      path: apiPaths.users,
    });
    if (!res.error) {
      let usersObj = res.results.reduce((users, user) => {
        users[user._id] = user;
        return users;
      }, {});
      setUsers(usersObj);
    } else {
      message.error(res.error_description);
    }
  };

  const COLUMNS = [
    {
      title: "Phone Number",
      dataIndex: "contact_number",
      fixed: "left",
      width: 150,
      filterType: "search",
    },
    {
      title: "Full Name",
      dataIndex: "fullname",
      width: "150px",
      filterType: "search",
    },
    {
      title: "City",
      dataIndex: "city",
      width: "120px",
    },
    {
      title: "Wallet Balance",
      dataIndex: "wallet",
      width: "120px",
      render: (data) => {
        return data ? data.new_balance : 0;
      },
    },
    {
      title: "Ia Admin",
      dataIndex: "is_admin",
      width: "100px",
      filters: [
        {
          text: "Yes",
          value: true,
        },
        {
          text: "No",
          value: false,
        },
      ],
      onFilter: (value, record) => value == record.is_admin,
      render: (text) => {
        return text ? "Yes" : "No";
      },
    },
    {
      title: "Ia Supervisor",
      dataIndex: "is_supervisor",
      width: "120px",
      filters: [
        {
          text: "Yes",
          value: true,
        },
        {
          text: "No",
          value: false,
        },
      ],
      onFilter: (value, record) => value == record.is_supervisor,
      render: (text) => {
        return text ? "Yes" : "No";
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      width: "150px",
      filterType: "date",
      render: (_, record) => {
        return (
          <div style={{ color: "#a7a7a7", fontSize: 11 }}>
            {moment(record.created_at).fromNow()}
          </div>
        );
      },
    },
    {
      title: "Updated By",
      dataIndex: "coordinates",
      width: "150px",
      render: (_, record) => {
        return (
          <div>
            <div>
              {record.updated_by
                ? record.updated_by?.fullname
                : record.created_by?.fullname}
            </div>
            <div style={{ color: "#a7a7a7", fontSize: 11 }}>
              {moment(record.updated_at).fromNow()}
            </div>
          </div>
        );
      },
    },
  ];

  const handleRowCanceled = () => {
    setShowUserModal(false);
  };

  const handleRowEdit = (idx) => {
    setEditingKey(idx);
    setShowUserModal(true);
  };

  const handleRowSave = async (row) => {
    let key = editingKey;
    const res = await apiRequest({
      path: apiPaths.users + `/${key}`,
      method: "PUT",
      data: row,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    users[editingKey] = res;
    setUsers({ ...users });
    setEditingKey(null);
    setShowUserModal(false);
  };

  return (
    <div style={{ height: "80vh" }}>
      {allowEdit ? (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: 10,
          }}
        >
          <Tooltip title="Add User">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setShowAddUserModal(true);
              }}
            />
          </Tooltip>
        </div>
      ) : null}
      <div style={{ height: "90%", marginTop: 30 }}>
        <DynamicTable
          dataSource={Object.values(users)}
          columns={COLUMNS}
          rowKey="_id"
          requireEdit={allowEdit}
          scroll={{
            // x: 2250,
            y: "65vh",
          }}
          pagination={true}
          editHandler={(record) => handleRowEdit(record._id)}
        />
      </div>
      {showUserModal ? (
        <UserModal
          open={true}
          onSave={handleRowSave}
          onCancel={handleRowCanceled}
          data={users[editingKey]}
        />
      ) : null}
      {showAddUserModal ? (
        <AddUserModal
          open={true}
          onSave={(user) => {
            setUsers(Object.values({ [user._id]: user, ...users }));
            setShowAddUserModal(false);
          }}
          onCancel={() => {
            setShowAddUserModal(false);
          }}
        />
      ) : null}
    </div>
  );
}

export default Users;
